import React, { useEffect, useRef, useState } from 'react'
import TopNavigation from '../Components/navigation/TopNavigation'
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import bannerHero from './../assets/weddingrings.png';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import MainFooter from '../Components/footer/MainFooter';
import CreateOnvite from '../Components/modals/CreateOnvite';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { logout } from '../reduxAuth/authSlice';

function Onsites() {

  const [showModal, setShowModal]                                     = useState(false);
  const amountFigure = "350.00";
  const {user}                                                        = useSelector((state) => state.auth);
  const [processing, setProcessing]                                   = useState(false);

  const [createOnsite, setCreateOnsite]                               = useState([]);
  const [listOfWeddings, setListOfWeddings]                           = useState([]);
  const [page, setPage]                                               = useState(1);

  const [show, setShow]                                               = useState(false);
  const dispatch                                                      = useDispatch();

  useEffect(() => {
      handleCurrentWeddings();
      if(user){
        handleGetPayment();
      }      
  },[])

  const handleCurrentWeddings = async () => {
      try{

        setProcessing(true);
        const response = await axios.get(CONSTANTS.API_URL +"annivites/list/v1/onvite/" + page);
        
        setListOfWeddings(response.data);
        setProcessing(false);
    }catch(errorData){
      setProcessing(false);
      console.log(errorData);
    }
  }

  const handleGetPayment = async () => {
      try{
        const response = await axios.get(CONSTANTS.API_URL +"payment/claim/v1/check/" + user._id, {
          headers: {
            'token': 'Bearer '+ user.accessToken
          }
        });
        setCreateOnsite(response.data);
      }catch(er){
        console.log(er);
     
        if(er.status === 403 && er.response.data === "Token is not valid!"){
          console.log("log user out");
           dispatch(logout());
        }
      }
  }

  const handlePayFastNow = async () => {
      try {
        
         const cartOnvite ={ 
               "amount": amountFigure,               
               "item_name": "Onvite - Wedding Invite",               
               "name_first" : user.name,
               "name_last" : user.surname,
               "email_address" : user.email,
            };  

        const resData = await axios.post(CONSTANTS.URL_HOME +"payfast/process/api.php", cartOnvite, {
                      headers: { 
                          'token': 'Bearer ' + user.accessToken
                    }
                  });
        
     
        if (resData.data.payfast_url) {
              window.location.href = resData.data.payfast_url;
          } else {
              toast.warning('Error: PayFast URL not received from backend.');
          }
      } catch (err) {
        console.error("Payment Error:", err);
        toast.error("Something went wrong. Please try again later.")
      }
  };

  const insertPayment = async () => {
      try{

        const orderId = "200" + Math.floor(Math.random() * 900 + 100);
        const cartOnvite ={ 
               "userId": user._id,               
               "title": "Onvite - Wedding Invite",               
               "orderId" : orderId,
               "full_name" : user.name + " " + user.surname,
               "email" : user.email,
               "price" : amountFigure,
               "paymentStatus" : "COMPLETE",
               "currency" : "zar",
               "claimed" : false,
            };  

            console.log(cartOnvite);
         const resData = await axios.post(CONSTANTS.API_URL +"payment/test/create", cartOnvite);
         toast.success("Payment successfull.");
         console.log(resData);
      }catch(err){
        console.log(err);
      }
  }

  return (
    <div className="main-layer">
        <Helmet>
                    <title>Lovedripp - Onsites </title>
        </Helmet>
        <TopNavigation title={"Onsites"} classBack="full-white" />
        <div className="content-layer">
            <div className="banner-photo-show middle-align txt-white" 
                style={{backgroundImage: `url("${bannerHero}")`}}>     
                <div className="info-hero-intro">
                    <h1 className="head-styling-font">Welcome to our Onsites</h1>
                    <div className="sub-text-hero">
                    Our list of special anniversaries collected for luxurious displays that we refer to as <strong>annisites</strong>  
                    </div>
                </div>                 
            </div>
            
            <div className="section-item">
             
                <div className="container">
                  <div className="pay-card">
                    <div className="pay-card-inner-bd">
                      <h2>R {amountFigure} </h2>
                       {
                        user ? (
                          <div className="edit-create-layer">
                            {
                              /*
                              <button className="btn btn-inverted-main" onClick={() => insertPayment()}>
                                Create Onvite for up and coming wedding
                              </button>
                              */
                            }
                           
                              {
                                createOnsite.length > 0 && (
                                  <>
                                  <button className="btn btn-main mgright10" onClick={() => setShowModal(true)}>
                                      <span className="mgright10">+</span>
                                      <span>Create Onvite</span>
                                  </button>
                                  <CreateOnvite 
                                    show={showModal} 
                                    onClose={() => setShowModal(false)} 
                                    user={user}
                                    createOnsite={createOnsite} />
                                  </>
                                )
                              }
                              <div className="purchase">
                                Want to purchase your own onvite to invite your family and friends, pay then create your own.
                              </div>
                              <button className="btn btn-inverted-main" onClick={handlePayFastNow}>
                                Pay Now
                              </button>                              
                          </div>
                        )
                        :
                        <h3>Please register and login on the authencation page in order to purchase your own onvite</h3>
                      }
                    </div>
                  </div>
                   
                  <div className="row">
                   
                    {
                        listOfWeddings &&
                        listOfWeddings.length > 0 && (
                        listOfWeddings.map((onviteItem, index) => {
                            return <div className="col-md-3" key={index}>
                            
                                      <Link to={"/couple-event/" + onviteItem._id}
                                        className="card-frame">
                                        <div className="photoframe">
                                          {
                                            onviteItem.featureUrl.length > 0 ? 
                                              <div className="image-photo"
                                                style={{backgroundImage: `url("${onviteItem.featureUrl}")`}}>
                                              </div>
                                              :
                                              <div className="color-photo">

                                              </div>
                                          }
                                         
                                          <div className="phrame-content">
                                            <h3>{onviteItem.spouseA} & {onviteItem.spouseB}</h3> 
                                            <div className="event-date">{onviteItem.weddingDate}</div>
                                          </div>
                                        </div>   
                                      </Link>                              
                                      
                                  </div>
                          })
                        )
                      }
                  </div>
                </div>
            </div>
        </div>
        {
            processing && (
                <div className="processing-spinner">
                        <img src={CONSTANTS.SMALL_PROCESSING} className="pro-spin" />
                </div>
            )
       }
       <MainFooter />
    </div>
  )
}

export default Onsites